import theme from 'ThemeProvider/theme';
import sx from 'utils/createSx';

export default sx({
  dialog: {
    zIndex: 1400,
  },
  backdrop: {
    backgroundColor: 'rgba(0, 0, 0, 0.55)',
  },
  paper: {
    borderRadius: '24px',
    px: { xs: 3, sm: 5 },
    py: { xs: 4, sm: 5 },
    mx: 2,
    maxWidth: 480,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    boxShadow: '0 16px 48px rgba(0, 0, 0, 0.2)',
  },
  logo: {
    display: 'block',
    height: 72,
    width: 'auto',
    maxWidth: 220,
    objectFit: 'contain',
    mx: 'auto',
    mb: 3,
  },
  title: {
    fontWeight: 700,
    fontSize: { xs: '1.15rem', sm: '1.35rem' },
    lineHeight: 1.35,
    color: theme.palette.text.primary,
    mb: 1.5,
  },
  subtitle: {
    fontSize: '0.95rem',
    color: theme.palette.text.secondary,
    mb: 4,
    lineHeight: 1.5,
  },
  actions: {
    display: 'flex',
    flexDirection: { xs: 'column', sm: 'row' },
    gap: 1.5,
    width: '100%',
  },
  outlinedButton: {
    flex: 1,
    borderRadius: '999px',
    py: 1.25,
    px: 2,
    textTransform: 'none',
    fontWeight: 600,
    borderWidth: 1.5,
    borderColor: theme.palette.primary.main,
    color: theme.palette.primary.main,
    '&:hover': {
      borderWidth: 1.5,
      borderColor: theme.palette.primary.dark,
      backgroundColor: 'rgba(201, 108, 30, 0.08)',
    },
  },
  confirmButton: {
    flex: 1,
    borderRadius: '999px',
    py: 1.25,
    px: 2,
    textTransform: 'none',
    fontWeight: 600,
    backgroundColor: theme.palette.primary.main,
    color: '#fff',
    '&:hover': {
      backgroundColor: theme.palette.primary.dark,
    },
  },
});
